<template>
  <ai-card
    class="FacilityCard"
    :picture="picture"
    :label="goldSticker?.label ?? ''"
    :title="title"
    :title-capitalized="true"
    :description="description"
    lazy-load-image>
    <ul>
      <li v-if="cuisineType" class="FacilityCard-line">
        <ai-icon
          name="24-7_dining"
          namespace="amenities"
          :description="$t('accessibility.description.facilityCardCuisineType')"
          class="FacilityCard-lineIcon" />
        <ai-typo as="span" variant="paragraph-04-regular">
          {{ cuisineType }}
        </ai-typo>
      </li>

      <li v-if="openingHours" class="FacilityCard-line">
        <ai-icon
          :description="$t('accessibility.description.facilityCardSchedules')"
          name="time"
          class="FacilityCard-lineIcon" />
        <ai-typo as="span" variant="paragraph-04-regular">
          {{ openingHours }}
        </ai-typo>
      </li>
    </ul>

    <template #actions>
      <ai-button
        v-if="menuLink"
        as-link
        variant="tertiary"
        :icon-right="'button-arrow-right' as IconName"
        :aria-pressed="ariapressed"
        :label="$t('hotel.hotelFacilities.cta')"
        :aria-label="$t('accessibility.description.facilityMenuButton')"
        :url="menuLink"
        target="_blank"
        slim
        small />
    </template>
  </ai-card>
</template>

<script setup lang="ts">
import type { AiPicture, GoldSticker } from '~~/domains/graphql';
import type { IconName } from '~~/domains/ux/atoms/AiIcon/types';

type Props = {
  title: string;
  id: string;
  description: string;
  picture?: AiPicture;
  goldSticker?: GoldSticker;
  cuisineType?: string;
  openingHours?: string;
  menu?: string;
  menuUrl?: string;
};
const props = defineProps<Props>();

const ariapressed = ref<boolean>(false);

const menuLink = computed(() => props.menuUrl ?? props.menu);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';

.FacilityCard {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.FacilityCard-line {
  margin-bottom: constants.$margin-00;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:last-child {
    margin-bottom: constants.$margin-03;
  }
}

.FacilityCard-lineIcon {
  margin-right: constants.$margin-00;
}
</style>
